import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import * as actions from './duck';

import DynamicFormEdit from '$DynamicForms/DynamicFormEdit';
import { Spinner } from '$HVUI';
import colors from '$HVUI/colors.module.less';

export class Forms extends React.Component {
    componentDidMount() {
        this.loadForms();
    }
    componentDidUpdate(prevProps) {
        const prevForm = prevProps.activeForm || {};
        const newForm = this.props.activeForm || {};

        const { activeSectionIndex: prevSection, slug: prevSlug } = prevForm;
        const { activeSectionIndex: newSection, slug: newSlug } = newForm;

        if (
            (prevSlug != newSlug || prevSection != newSection) &&
            window.scrollY > 40
        ) {
            // if you're already pretty close to the top, don't jump around
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
    }
    loadForms = () => {
        const {
            assessments,
            getNextFormAndSetActive,
            getSpecificFormAndSetActive,
            match
        } = this.props;

        const definitionUUID =
            match && match.params && match.params.definitionUUID;
        if (definitionUUID) {
            getSpecificFormAndSetActive({ definitionUUID });
        } else {
            getNextFormAndSetActive({ review: !assessments });
        }
    };
    handleSubmit(values) {
        const { submitForm, assessments } = this.props;

        const review = !assessments;

        return submitForm(values, { review });
    }
    render() {
        const {
            activeForm,
            assessments,
            decrementActiveSection,
            intl,
            submitPartial
        } = this.props;

        const language = intl?.locale || 'en-US';

        /*
        `activeForm` either returns the current form to be displayed, or the string 'complete' if there are no more forms in this section.

        `assessments` is a boolean. true indicates whether `activeForm` is in the assessments portion of intake, falsey means it's registration.

        In other words, the server param review=true is equivalent to asessments=false

        We can (and should) make this a lot more semantic when we switch to Form Groups / Kinds on the server.
        */

        if (activeForm === 'complete') {
            if (assessments) {
                return <Redirect to="/complete" />;
            }
            return <Redirect to="/review" />;
        }

        if (activeForm == null)
            return (
                <>
                    <Spinner size={30} />
                </>
            );

        const {
            activeSectionIndex,
            fields: rawFields,
            initialValues,
            lastSection,
            slug,
            title
        } = activeForm;

        const FormComponent = DynamicFormEdit(slug);

        const fields = rawFields.filter(
            field => field.section === activeSectionIndex
        );
        return (
            <div id="form-wrapper">
                <div>
                    <h1
                        style={{
                            color: colors.grayDk,
                            marginTop: '32px',
                            marginBottom: '0px'
                        }}
                    >
                        {title}
                    </h1>
                    {/* submitPartial has to be included here for redux-form */}
                    <FormComponent
                        activeForm={activeForm}
                        activeSectionIndex={activeSectionIndex}
                        decrementActiveSection={decrementActiveSection}
                        destroyOnUnmount={false}
                        fields={fields}
                        initialValues={initialValues}
                        key={slug}
                        lastSection={lastSection}
                        onSubmit={this.handleSubmit.bind(this)}
                        submitPartial={submitPartial}
                        language={language}
                    />
                </div>
            </div>
        );
    }
}

export const mapStateToProps = (state, ownProps) => {
    const { activeForm, introduction = {} } = state;
    const { organization = {}, isKiosk } = introduction;
    const orgID = organization.id;
    const isScheduling = organization.assessment_scheduling;

    return Object.assign(
        {
            activeForm,
            orgID,
            isScheduling,
            isKiosk
        },
        ownProps
    );
};

export default connect(mapStateToProps, actions)(injectIntl(Forms));
